module.exports = "/_next/static/images/7fd0bcbc550dee3ba1140ca2c9a1e15d-mulher-perfil-segurando-cartao-md@2x.jpg.webp";